import React, { Component, Fragment } from 'react';
import { shape, bool } from 'prop-types';
import classNames from 'classnames';
import SwipeableViews from 'react-swipeable-views';
import BorrowerCard from './BorrowerCard';

class RenderMobileBorrowerCards extends Component {
  state = { currentIndex: 0 };
  render = () => {
    const {
      borrowers: { primaryBorrower, secondaryBorrower },
      isJoint,
    } = this.props;
    if (secondaryBorrower && isJoint) {
      return (
        <Fragment>
          <SwipeableViews
            enableMouseEvents
            style={{ height: '100%', overflow: 'inherit' }}
            slideStyle={{ overflow: 'inherit' }}
            className="borrower-cards__swipeable-view-container"
            slideClassName="borrower-cards__swipeable-view-slide"
            index={this.state.currentIndex}
            onChangeIndex={index => this.setState({ currentIndex: index })}
          >
            <BorrowerCard borrower={primaryBorrower} />
            <BorrowerCard borrower={secondaryBorrower} isSecondary />
          </SwipeableViews>
          <div className="borrower-cards__swipeable-view-indicator-container">
            {[0, 1].map(index => {
              const indicatorClassNames = classNames('borrower-cards__swipeable-view-indicator', {
                'borrower-cards__swipeable-view-indicator--current': index === this.state.currentIndex,
              });
              return <div className={indicatorClassNames} key={`swipeable-view-indicator-${index}`} />;
            })}
          </div>
        </Fragment>
      );
    }
    return <BorrowerCard borrower={primaryBorrower} />;
  };
}

RenderMobileBorrowerCards.propTypes = {
  borrowers: shape({}),
  isJoint: bool,
};

RenderMobileBorrowerCards.defaultProps = {
  borrowers: {},
  isJoint: false,
};

const BorrowerCards = ({ borrowers, isJoint }) => {
  const { primaryBorrower, secondaryBorrower } = borrowers;
  return (
    <div className="borrower-cards">
      <div className="borrower-cards__title">personal information</div>
      <div className="borrower-cards__card-container borrower-cards__card-container--mobile">
        <RenderMobileBorrowerCards borrowers={borrowers} isJoint={isJoint} />
      </div>
      <div className="borrower-cards__card-container borrower-cards__card-container--tablet-and-up">
        <BorrowerCard borrower={primaryBorrower} isSingleCard={!secondaryBorrower || !isJoint} />
        {secondaryBorrower && isJoint && <BorrowerCard borrower={secondaryBorrower} isSecondary />}
      </div>
    </div>
  );
};

BorrowerCards.propTypes = {
  borrowers: shape({
    primaryBorrower: shape(),
    secondaryBorrower: shape(),
  }).isRequired,
  isJoint: bool,
};

BorrowerCards.defaultProps = {
  isJoint: false,
};

export default BorrowerCards;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/components/BorrowerCards/BorrowerCards.scss');